<template>
    <div>
        <v-row justify="center" style="background-color: #06599D;">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <h1 style="color: white; font-weight: 300;" class="text-h3">
                                <LanguagePlaceholder is-html default-text="Distributor Dashboard" />
                            </h1>
                            <br />
                            <p>
                                <b>WHAT is this report: </b>
                                This page shows you information on the number of Dell partners purchasing with you, as well as how many have signed up to RISE to benefit from rewards. The data in this report runs approximately 2 weeks behind current date.
                                <br /><br />
                                <b>HOW do you use it: </b>
                                Use this Dashboard if you need some quick numbers around your partner totals. For more in depth information, use the downloadable reports on your Home Page.
                            </p>
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>

                    <v-row class="my-2">
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select class="text-white" v-model="selectedQuarter" :items="quarters"
                                    variant="outlined"
                                    aria-label="Select Incentive Period">
                                    <template v-slot:label>
                                        <LanguagePlaceholder is-html default-text="Select Incentive Period" />
                                    </template>
                                </v-select>
              
                            </div>

                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div>
                                <v-select :items="countries" return-object v-model="selectedCountry" class="text-white"
                                    item-title="country" item-value="country"
                                    variant="outlined"
                                    aria-label="Select Location">
                                    <template v-slot:label>
                                        <LanguagePlaceholder is-html default-text="Select Location" />
                                    </template>
                                </v-select>
                            </div>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row class="my-2"> 
                            <div>
                                <v-btn :disabled="selectedCountry == '' || selectedCountry == null" @click="clickSubmit"
                                color="white" variant="outlined"><LanguagePlaceholder default-text="Submit" /></v-btn>
                                                        </div>
                    </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <!-- <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <p class="general-text">
                    Please note that your data is currently under review. Data will be available soon.
                </p>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row> -->
        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row justify="space-around" align-content="stretch">
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Total number of partners purchasing with you" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.formattedNumber(reportData.totalPartnersPurchasingWithYou) }}
                                </strong>
                            </h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Partners with eligible sales - RISE IN" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.formattedNumber(reportData.partnersWithEligibleSales_RISEIN) }}
                                </strong>
                            </h2>
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="space-around" align-content="stretch">
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Total Revenue - RISE IN" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.currencyUSD(reportData.totalRevenue_RISEIN) }}
                                </strong>
                            </h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Total Revenue - RISE OUT" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.currencyUSD(reportData.totalRevenue_RISEOUT) }}
                                </strong>
                            </h2>

                        </div>
                    </v-col>
                </v-row>
                <v-row justify="space-around" align-content="stretch">
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Total Number of Eligible Units RISE IN" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.formattedNumber(reportData.totalNumberOfEligibleUnits_RISEIN) }}
                                </strong>
                            </h2>

                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="h-100 elevation-3 text-white text-center pa-10" style="background-color: #1D5A9A;">
                            <p>
                                <LanguagePlaceholder default-text="Total Number of Eligible Units RISE OUT" />
                                
                            </p>
                            <h2 class="my-3 text-white">
                                <strong>
                                    {{ $filters.formattedNumber(reportData.totalNumberOfEligibleUnits_RISEOUT) }}
                                </strong>
                            </h2>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useRegistrationStore } from '@/stores/registration'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import PleaseNote from '@/components/PleaseNote.vue'

const systemStore = useSystemStore()
const registrationStore = useRegistrationStore()

const quarters = ref([])
const selectedQuarter = ref('')
const selectedCountry = ref('')

const affinityId = ref(0)
const reportData = ref({
    totalPartnersPurchasingWithYou: 0,
    partnersWithEligibleSales_RISEIN: 0,
    totalRevenue_RISEIN: 0,
    totalRevenue_RISEOUT: 0,
    totalNumberOfEligibleUnits_RISEIN: 0,
    totalNumberOfEligibleUnits_RISEOUT: 0
})
const countries = ref([])

onMounted(() => {
    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentQuarters === true)
                .map(q => q.quarter)

            selectedQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })

    registrationStore.GetEMEACountries().then(result => {
        countries.value = result.countries
    }).catch(error => {
        console.log('disti dashb get countries', error)
    })
})

const clickSubmit = () => {
    getReportData()
}

const getReportData = () => {
    systemStore.getDistributorDashboardData(selectedQuarter.value, selectedCountry.value.country).then(result => {
        reportData.value = result.reportData
    }).catch(error => {
        console.log('distributor dashboard, get data', error)
    })
}


</script>